import FieldsTranslation from "graphql/fields/FieldsTranslation";
import FieldsTimeslotKindException from 'graphql/fields/FieldsTimeslotKindException'

export default `
	guid
	name
	kind
	sub_kind
	icon
	sub_icon
	secondary_sub_icon
	icon_color
	background_color
	can_overlap_with_booking
	can_only_select_one_per_day
	can_book_from
	can_book_until
	can_cancel_until
	can_scan_presence_qr_code
	can_scan_presence_qr_code_from
	can_scan_presence_qr_code_until
	show_capacity
	show_time
	show_capacity_in_timeslot
	instructions_link
	credit_amount
	extra_parameters
	active
	
	translations {
		${FieldsTranslation}
	}
	
	exceptions {
		${FieldsTimeslotKindException}
	}
`;
